import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';

import './index.css';
import App from './App';
import './index.scss';
import './lib/socket';

import configureStore from './redux/store';

const history = createHistory();
const { store, store: { dispatch, getState } } = configureStore(history);


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// registerServiceWorker();

export { store, getState, dispatch };



// WEBPACK FOOTER //
// ./src/index.js